<div class="card">
    <p-treeTable #tt [value]="mappedData" styleClass="p-treetable-gridlines" [columns]="cols" [paginator]="true"
        [rows]="5" [scrollable]="true" [tableStyle]="{ 'max-width': '80rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>Item</th>
                <th>Plant</th>
                <th>PO No</th>
                <th>Planned Quantity</th>
            </tr>
            <tr>
                <th></th>
                <th class="text-center">Actual Quantity</th>
                <th class="text-center">Batch No</th>
                <th class="text-center">Serial No</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode" (click)="setSelectedRowIndex(rowData)">
                <td *ngFor="let col of columns; let i = index;">
                    <ng-container *ngIf="setButton(rowNode)">
                        <!-- <p-button *ngIf="i === 0" icon="pi pi-plus" [rounded]="true" (click)="showDialog()"
                            [style]="{ 'margin-right': '.5em' }"></p-button> -->
                        <p-button *ngIf="i === 0" icon="pi pi-plus" [rounded]="true" (click)="showDialog(rowNode)"
                            [style]="{ 'margin-right': '.5em' }"></p-button>
                    </ng-container>
                    <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                    {{ rowData[col.field] }}
                </td>
            </tr>
        </ng-template>
    </p-treeTable>

    <p-dialog header="Schedule Batch Details" [closable]="false" [(visible)]="visible" [modal]="true"
        [style]="{ width: '65rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
        <ng-template pTemplate="content">
            <p-table [value]="[selectedRow]" editMode="row" styleClass="p-datatable-sm"
                [tableStyle]="{ 'min-width': '50rem'}">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Item No</th>
                        <th>Plant</th>
                        <th>PO No</th>
                        <th>Planned Quantity</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-selectedRow let-editing="editing" let-rowIndex="rowIndex">
                    <tr [pEditableRow]="selectedRow">
                        <td>
                            {{ selectedRow.itemNo }}
                        </td>
                        <td>
                            {{ selectedRow.plant }}
                        </td>
                        <td>
                            {{ selectedRow.pono }}
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-inputNumber [(ngModel)]="selectedRow.qty" [min]="0"
                                        (ngModelChange)="validatePlannedQuantity(selectedRow, rowIndex)"></p-inputNumber>
                                    <div *ngIf="quantityExceedsMax" class="text-red-300">Exceed total quantity</div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ selectedRow.qty }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <div class="flex align-items-center justify-content-center gap-2">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" class="p-button-rounded p-button-text"
                                    (click)="onRowEdit(selectedRow)"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onRowEditSave(selectedRow)"
                                    [disabled]="quantityExceedsMax"
                                    class=" p-button-rounded p-button-text p-button-success mr-2"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    (click)="onCancleEdit(selectedRow)" icon=" pi pi-times"
                                    class="p-button-rounded p-button-text p-button-danger"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

            <!-- </div><br> -->
            <div *ngIf="displayedData.length > 0">
                <p-table [value]="displayedData" styleClass="p-datatable-sm" [tableStyle]="{ 'min-width': '50rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Batch No</th>
                            <th>Actual Quantity</th>
                            <th>Serial No</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>{{ product.BatchNo }}</td>
                            <td>{{ product.actualQTY }}</td>
                            <td>{{ product.serialNO }}</td>
                            <td>
                                <p-button 
                                pRipple 
                                icon="pi pi-trash" 
                                severity="danger" 
                                [rounded]="true" 
                                [outlined]="true" 
                                (click)="deleteSchedule(product)"
                                />
                            </td>
                        </tr>
                    </ng-template>
                </p-table><br><br>
            </div>

            <form [formGroup]="scheduleBatchForm" *ngIf="isAddBatch">
                <div class="flex flex-wrap gap-3 mb-4">
                    <div class="flex-auto">
                        <label for="number" class="font-bold block mb-2">Act. QTY <span
                                class="required-asterisk">*</span></label>
                        <p-inputNumber formControlName="actualQTY" [min]="0" 
                            (ngModelChange)="validateQuantity($event)"></p-inputNumber>
                        <div *ngIf="quantityExceedsMax" class="text-red-300">Actual Quantity cannot exceed planned
                            quantity</div>
                    </div>  
                    <div class="flex-auto">
                        <label for="text" class="font-bold block mb-2">Batch No <span
                                class="required-asterisk">*</span></label>
                        <input pInputText formControlName="BatchNo"  />
                        <div *ngIf="scheduleBatchForm.get('BatchNo')?.hasError('existingBatchNo') && scheduleBatchForm?.get('BatchNo')?.touched"
                            class="text-red-300">
                            This batch number already exists.
                        </div>
                        <div *ngIf="scheduleBatchForm.get('BatchNo')?.hasError('duplicateBatchNo') && scheduleBatchForm?.get('BatchNo')?.touched"
                            class="text-red-300">
                            This batch number is already added
                        </div>
                    </div>
                    <div class="flex-auto">
                        <label for="number" class="font-bold block mb-2">Serial No </label>
                        <input pInputText formControlName="serialNO"  />
                    </div>
                </div>
            </form>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="text-center">
                <div style="display: flex; justify-content: center;" class="text-red-400 mb-4" *ngIf="isQtyEmpty">Your Actual Quantity 0</div>
                <p-button (click)="onClose()"  label="Close"></p-button>
                <p-button (click)="createScheduleBatch()" label="Save"
                    [disabled]="quantityExceedsMax || scheduleBatchForm.invalid || scheduleBatchForm.get('actualQTY')?.value === null || scheduleBatchForm.get('BatchNo')?.value === null"></p-button>
                <p-button (click)="onClickAdd()" [disabled]="isAddBtnDisable"  label="Add"></p-button>
    
            </div>
        </ng-template>
    </p-dialog>

    <button type="button" [disabled]="selectedRows.length === 0" (click)="createShipmentASN()"
        class="p-button p-button-primary">Create Shipment</button>
</div>
<p-confirmDialog [style]="{ width: '450px' }" />
<p-toast></p-toast>